import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
// import { NotFoundComponent } from './templates/not-found/not-found.component';
// import { TemplatesComponent } from './templates/templates.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  
  // { path: 'not-found', component: NotFoundComponent },
  // { path: 'tree', component: TreeComponent },
  { path: '**', redirectTo: '/index.html' }
];

export { appRoutes };

